import type { FC } from "react";

interface ComposeContextProvidersProps {
  components: Array<React.JSXElementConstructor<React.PropsWithChildren<any>>>;
  children: React.ReactNode;
}

export const ComposeContextProviders: FC<ComposeContextProvidersProps> = ({ components, children }) => {
  return (
    <>
      {components.reduceRight((accumulator, Component) => {
        //TODO clean this up
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        return <Component>{accumulator}</Component>;
      }, children)}
    </>
  );
};
